import { RelationEmpty, RelationSchema } from "$lib/data/schema/_relation"
import { CoordinateEmpty, CoordinateSchema } from "$lib/data/schema/coordinate"
import { z } from "zod/v4"

export const FormDocumentSchema = z.object({
  id: z.number().default(0),
  ref_id: z.string().default(""),
  name: z.string().default(""),
  description: z.string().default(""),
  document: z.custom<File | null>().default(null),
  document_url: z.string().default(""),
  document_delete: z.number().default(0),
})
export type FormDocument = z.infer<typeof FormDocumentSchema>
export const FormDocumentEmpty = FormDocumentSchema.parse({})

export const CustomerNooSchema = z.object({
  id: z.number().default(0),
  number: z.string().default(""),
  datetime: z.string().default(""),
  name: z.string().default(""),
  category: RelationSchema.default(RelationEmpty),
  division: RelationSchema.default(RelationEmpty),
  bp_group: RelationSchema.default(RelationEmpty),
  bp_class: RelationSchema.default(RelationEmpty),
  delivery: RelationSchema.default(RelationEmpty),
  payment_limit: z.number().default(0),
  payment_term: RelationSchema.default(RelationEmpty),
  tax_name: z.string().default(""),
  tax_number: z.string().default(""),
  contact_name: z.string().default(""),
  contact_phone: z.string().default(""),
  province: RelationSchema.default(RelationEmpty),
  city: RelationSchema.default(RelationEmpty),
  address: z.string().default(""),
  coordinate: CoordinateSchema.default(CoordinateEmpty),
  radius: z.number().default(0),
  approval: RelationSchema.default(RelationEmpty),
  documents: z.array(FormDocumentSchema).default([]),
})
export type CustomerNoo = z.infer<typeof CustomerNooSchema>
export const CustomerNooEmpty = CustomerNooSchema.parse({})

export const FormSchema = z.object({
  id: z.number().default(0),
  number: z.string().default(""),
  datetime: z.string().default(""),
  name: z.string().default(""),
  category_id: z.number().default(0),
  category_name: z.string().default(""),
  division_id: z.number().default(0),
  division_name: z.string().default(""),
  bp_group_id: z.number().default(0),
  bp_group_name: z.string().default(""),
  bp_class_id: z.number().default(0),
  bp_class_name: z.string().default(""),
  delivery_id: z.number().default(0),
  delivery_name: z.string().default(""),
  payment_limit: z.number().default(0),
  payment_term_id: z.number().default(0),
  payment_term_name: z.string().default(""),
  tax_name: z.string().default(""),
  tax_number: z.string().default(""),
  contact_name: z.string().default(""),
  contact_phone: z.string().default(""),
  province_id: z.number().default(0),
  province_name: z.string().default(""),
  city_id: z.number().default(0),
  city_name: z.string().default(""),
  address: z.string().default(""),
  coordinate: CoordinateSchema.default(CoordinateEmpty),
  radius: z.number().default(0),
  documents: z.array(FormDocumentSchema).default([]),
})
export type FormData = z.infer<typeof FormSchema>
export const FormEmpty = FormSchema.parse({})
